var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-cms"},[_c('PageHeader',{attrs:{"title":"Email Templates"}}),_c('div',{staticClass:"cms-wrap pt-8"},[_c('div',{staticClass:"row"},[_c('EmailTemplate')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }